import { ApiProperty } from '@nestjs/swagger';
import { IsNotEmpty, IsUUID } from 'class-validator';

export class SwitchEmpresaDto {
  @ApiProperty({ example: 'cd88ac6a-2b0e-41bc-afd9-24b594cb8daf', description: 'ID de la empresa destino' })
  @IsNotEmpty({ message: 'empresa_id es requerido' })
  @IsUUID('all', { message: 'empresa_id debe ser un UUID válido' })
  empresa_id: string;
}
